
import { Prop, Component, Vue } from 'vue-property-decorator'

export enum OzBaseButtonHrefMode {
  Default = 'Default',
  DisplayOnly = 'DisplayOnly',
  HistoryPushState = 'HistoryPushState',
}

/**
 * Provides button functionality, but not styling.
 */
@Component({})
export default class OzBaseButton extends Vue {
  $el!: HTMLAnchorElement | HTMLButtonElement

  /**
   * Automatically uses an `<a>` tag if href is present, `<button>` otherwise.
   */
  @Prop({ default: undefined }) href?: string

  /**
   * Whether the button is disabled.
   */
  @Prop({ default: false }) disabled!: boolean

  /**
   * - `Default` - triggers a page reload
   * - `DisplayOnly` - `href` is for show only. Handle it using `@click`
   * - `HistoryPushState` - Changes current URL. Handle it using `@click`.
   */
  @Prop({ default: OzBaseButtonHrefMode.Default }) hrefMode?: OzBaseButtonHrefMode

  click(event: MouseEvent): void {
    if (this.hrefMode !== OzBaseButtonHrefMode.Default) event.preventDefault()
    if (this.disabled) return
    if (this.hrefMode === OzBaseButtonHrefMode.HistoryPushState) window?.history?.pushState(null, '', this.href)

    /**
     * Click event
     * @property {MouseEvent} event click event
     */
    this.$emit('click', event)
  }

  handleSpaceKey(event: KeyboardEvent): void {
    // Anchor elements with roles set to ‘button’ can only be activated with the ‘enter’ key,
    // whereas a button element would be triggered by both ‘space’ and ‘enter’ keys.
    // Adding a space keypress event listener and calling this method should ensure
    // that the element triggers the same event that a click, or pressing the ‘enter’ key
    // would (mouse click event) and execute the default behavior.
    const SPACE_KEYCODE = event.code === 'Space'
    if (this.href && SPACE_KEYCODE) {
      event.preventDefault()
      // Prevent default scrolling behaviour on anchor tags
      const linkButton = this.$el as HTMLAnchorElement
      linkButton.click()
    }
  }
}
